import React from 'react'
import { Link } from 'react-router-dom'
import { CButton, CSpinner } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilArrowRight, cilCalendar, cilPlus } from '@coreui/icons'

import FixturesTable from 'src/components/common/FixturesTable'

// Fixtures tab of the Edit Team panel: the team's schedule (home or away) plus a shortcut
// into the regular Add Fixture panel with this team already picked. The rows are loaded by
// EditForm so the tab strip can show the count before this tab is opened.
const TeamFixtures = ({ fixtures, loading, canAddFixture, onAddFixture }) => (
  <div>
    <div className="d-flex justify-content-between align-items-center mb-1">
      <h6 className="fw-bold mb-0">Fixtures</h6>
      {canAddFixture && fixtures.length > 0 && (
        <CButton color="primary" variant="outline" size="sm" onClick={onAddFixture}>
          <CIcon icon={cilPlus} className="me-1" />
          Add Fixture
        </CButton>
      )}
    </div>
    <div className="text-medium-emphasis small mb-3">
      Fixtures this team plays in, home or away. Archived fixtures are not shown.
    </div>

    {loading && fixtures.length === 0 ? (
      <div className="text-center py-4">
        <CSpinner size="sm" color="primary" />
      </div>
    ) : fixtures.length === 0 ? (
      <div className="text-center rounded border py-4 px-3" style={{ borderStyle: 'dashed' }}>
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle text-primary mb-2"
          style={{ width: 42, height: 42, backgroundColor: 'rgba(var(--cui-primary-rgb), 0.12)' }}
        >
          <CIcon icon={cilCalendar} size="lg" />
        </div>
        <div className="fw-semibold">No fixtures yet</div>
        <div className="text-medium-emphasis small mb-3">
          Schedule this team&apos;s first fixture without leaving the panel.
        </div>
        {canAddFixture && (
          <CButton color="primary" size="sm" onClick={onAddFixture}>
            <CIcon icon={cilPlus} className="me-1" />
            Add first fixture
          </CButton>
        )}
      </div>
    ) : (
      <FixturesTable
        fixtures={fixtures}
        loading={loading}
        emptyLabel="This team has no fixtures yet."
      />
    )}

    <div className="mt-3 text-end">
      <Link to="/create-fixtures" className="small text-decoration-none">
        Manage all fixtures
        <CIcon icon={cilArrowRight} size="sm" className="ms-1" />
      </Link>
    </div>
  </div>
)

export default TeamFixtures
